module.exports = __webpack_public_path__ + "img/vhead.c40221c4.svg";